import React, {Component} from "react";
import moment from "moment";
import simpleFormat from "../../helpers/simple_format";
import {Button, Card} from "react-bootstrap";
import {intersection} from "lodash";
import EditNoteComponent from "./EditNoteComponent";
import {useSelector} from "react-redux";

const NoteComponent = ({note, setNotes}) => {
  const {currentUser} = useSelector((state) => state)
  const [action, setAction] = React.useState("show");

  if (action === "edit") {
    return <EditNoteComponent note={note} setAction={setAction} setNotes={setNotes}/>;
  }

  return (
    <Card>
      <div
        className="card-block"
        style={{
          backgroundColor: "white",
        }}
      >
        <div
          dangerouslySetInnerHTML={{__html: simpleFormat(note.body)}}
        />
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex flex-column">
            {!!note.author && (
              <small className="text-secondary">
                Author: {note.author.name}
              </small>
            )}
            <small className="text-secondary">
              Created On: {moment(note.created_at).format("llll")}
            </small>
            {moment(note.created_at).format() !==
              moment(note.updated_at).format() && (
                <small className="text-secondary">
                  Updated On: {moment(note.updated_at).format("llll")}
                </small>
              )}
            {note.contacted_at && (
              <small className="text-secondary">
                {"Contacted On"}:{" "}
                {moment(note.contacted_at).format("ll")}
              </small>
            )}
            {note.follow_up_at && (
              <small className="text-secondary">
                {"Follow Up On"}:{" "}
                {moment(note.follow_up_at).format("ll")}
              </small>
            )}
            {!!note.risk_level && (
              <small className="text-secondary text-capitalize">
                Risk Level: {note.risk_level.label}
              </small>
            )}
          </div>
          {note.author_id == currentUser.id &&
            (
              <Button
                size="sm"
                variant="link"
                onClick={() => {
                  setAction("edit");
                }}
              >
                Edit
              </Button>
            )}
        </div>
      </div>
    </Card>
  );
}

export default NoteComponent;
